import ReactHTMLParser from 'react-html-parser';

import DOMPurify from 'dompurify';
import PropTypes from 'prop-types';

import CustomIcon from '../../../common/CustomIcons';
import useIsMobile from '../../../common/utilities/useIsMobile';

import './styles/index.css';

const MarketNews = ({ item, linkLabel }) => {
  const { CCOM_Title: title, CCOM_PublishDate: publishedDate, url } = item;
  const { isMobile } = useIsMobile(1024);

  return !isMobile ? (
    <div className="news-content">
      <p>{publishedDate}</p>
      <h3 className="b">{ReactHTMLParser(title)}</h3>
      <a className="b" href={DOMPurify.sanitize(url)} target="_blank" rel="noreferrer" aria-label={linkLabel}>
        {linkLabel}
        <CustomIcon type="fwdArrow" size="24" />
      </a>
    </div>
  ) : (
    <a className="news-content" href={DOMPurify.sanitize(url)} target="_blank" rel="noreferrer" aria-label={linkLabel}>
      <p>{publishedDate}</p>
      <h3 className="b">{ReactHTMLParser(title)}</h3>
    </a>
  );
};

MarketNews.propTypes = {
  item: PropTypes.instanceOf(Object).isRequired,
  linkLabel: PropTypes.string.isRequired
};

export default MarketNews;
